import List from "components/list";
import { useParams } from "react-router-dom";
import { usePermissions } from "contexts/permission";
import { StatusCell } from "@/components/status/cell";
import { Button } from "ui/index";
import { Icon } from "components/index";
import { EDIT } from "icons/src";
import { useUpdateJob } from "@/modules/work/jobs/update/mutation";
import { eventBus } from "utils/eventBus";
import EmployeeInput from "components/employee/input";
import { UserFieldInput } from "permissions/components/user-field-input";
import { ROUTE } from "@/lib/utils";

export default function JobCoordinatorList() {
  const { employeeId } = useParams();
  const permissions = usePermissions();
  const canEditCoordinator = permissions.hasFieldAccess("jobs", "update", "coordinator");
  const userFilter = employeeId ? { _eq: employeeId } : { user: { _eq: "$CURRENT_USER" } };

  const storageKey = employeeId ? `profile-jc-jobs-${employeeId}` : "profile-jc-jobs";

  const updateJobMutation = useUpdateJob({
    onSuccess: () => {
      eventBus.emit("refresh:list", `jobs${storageKey}`);
    }
  });

  const fields = [
    "id",
    "name",
    "status",
    "coordinator.id",
    "coordinator.first_name",
    "coordinator.last_name",
    "coordinator.avatar",
    "project.name"
  ];

  const columns = [
    {
      id: "name",
      header: "Name",
      accessorKey: "name",
    },
    {
      id: "status",
      header: "Status",
      accessorKey: "status",
      cell: StatusCell,
    },
    {
      id: "project",
      header: "Project",
      accessorKey: "project.name"
    },

    {
      id: "coordinator",
      header: "Coordinator",
      hidden: !canEditCoordinator,
      href: false,
      cell: ({ row }) => {
        const job = row.original;
        return (
          <UserFieldInput
            targetItem={job.id}
            field="coordinator"
            collection="jobs"
            showWhenDisabled={false}
          >
            <EmployeeInput
              set="jobs_coordinating"
              value={job.coordinator}
              singleSelect={true}
              footer={({ setOpen, selectedEmployees }) => (
                <Button
                  onClick={() => {
                    const selectedEmployee = selectedEmployees?.[0];
                    if (selectedEmployee) {
                      updateJobMutation.mutate({
                        id: job.id,
                        values: {
                          coordinator: selectedEmployee,
                        },
                      });
                    }
                    setOpen(false);
                  }}
                >
                  Assign
                </Button>
              )}
            >
              <Button variant="ghost">
                <Icon icon={EDIT} />
              </Button>
            </EmployeeInput>
          </UserFieldInput>
        );
      }
    }
  ];

  const filters = {
    coordinator: userFilter,
    status: { _nin: ["archived", "closed", "cancelled"] },
  };

  return (
    <List
      title="Jobs"
      storageKey={storageKey}
      endPoint="jobs"
      filters={filters}
      columns={columns.filter(col => !col.hidden)}
      meta={{ fields }}
      sortBy="date_created"
      href={(item) => ROUTE.JOB(item.id)}
    />
  );
}
